import { tableService } from '@/api/';
import { defineStore } from 'pinia';
import { tools } from '@/utils/tools';
export const useMainTableStore = defineStore('getMainTableInfo', {
  state: () => ({
    columnFieldList: [], //列表字段
    enableList: [], //启用的字段
    multiTable: false //是否有嵌套
  }),
  actions: {
    // 获取列表字段及是否有嵌套
    getFieldAndNestInfo(params) {
      this.columnFieldList = [];
      this.multiTable = false;
      return new Promise((resolve, reject) => {
        tableService
          .getFieldAndNest(params)
          .then((json) => {
            const res = json.result;
            console.log(10231, res);
            this.multiTable = res?.multiTable || false; //是否有嵌套
            this.columnFieldList = res?.fields || []; //列表需要显示的字段，
            if (this.columnFieldList?.length) {
              const updateList = this.columnFieldList?.map((item) => {
                if (item?.fieldExt && [2, 3, 4, 5, 10].includes(item.fieldType)) {
                  const getFieldExt = tools.isJSON(item?.fieldExt) ? JSON.parse(item.fieldExt)?.filter((i) => i.isEnabled) : item?.fieldExt;
                  item.fieldExt = JSON.stringify(getFieldExt);
                }
                return item;
              });
              this.enableList = updateList; //启用的字段
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    //设置列表字段
    setColumnFieldList(fields) {
      this.columnFieldList = fields || [];
    }
  }
});
export default useMainTableStore;
